import React, { useMemo } from 'react';

import { useCompanies, useUsers } from '@adsk/alloy-provider';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip/es/Tooltip';

import { MentionData } from '../../consts';
import ShowMore from '../ShowMore';

export const MentionCompanyTooltip = ({
  mention,
  children,
}: {
  mention: MentionData;
  children?: React.ReactNode;
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const companies = useCompanies();
  const users = useUsers();
  const currentCompany = useMemo(
    () =>
      companies.data.find((company) => company.memberGroupId === mention.id),
    [companies.data, mention.id],
  );

  return (
    <Tooltip
      content={
        <div
          data-testid={`MentionCompanyTooltip_Content_${mention?.id}`}
          css={{
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'break-all',
          }}
        >
          <span>
            <div
              css={[
                theme.typography.labelMedium,
                { color: theme.colors.charcoal900 },
              ]}
            >
              {currentCompany?.name ||
                mention?.name ||
                T.translate('FORMER_COMPANY')}
            </div>
            <div
              css={[
                theme.typography.labelMedium,
                { color: theme.colors.charcoal700 },
              ]}
            >
              <ShowMore
                list={users.data
                  ?.filter((user) => user.companyId === currentCompany?.id)
                  .map((user) => user.name)}
              />
            </div>
          </span>
        </div>
      }
      triggerTarget={Tooltip.TRIGGER_TARGETS.TOOLTIP}
      variant={Tooltip.VARIANTS.LIGHT}
    >
      <span data-testid={`MentionCompanyTooltip_Trigger_${mention?.id}`}>
        @
        {children ||
          currentCompany?.name ||
          mention?.name ||
          T.translate('FORMER_COMPANY')}
      </span>
    </Tooltip>
  );
};
